import { connect } from 'react-redux'
import ContextMenu from './context-menu'
import { copyOrganisationFile } from '../../../../../../../stores/organisation-files/organisation-files.actions'
import { getOrganisationFile } from '../../../../../../../stores/organisation-files/organisation-files.selectors'
import { withRouter } from 'react-router-dom'

const mapStateToProps = (state, { id, history }) => {
  const file = getOrganisationFile(state, id)
  return {
    id: file.id
  }
}

const mapDispatchToProps = dispatch => ({ dispatch })

const mergeProps = (stateProps, { dispatch }, ownProps) => ({
  ...stateProps,
  ...ownProps,
  onCopy: () => {
    return dispatch(copyOrganisationFile(ownProps.id)).then(() =>
      ownProps.history.push('/my-files')
    )
  }
})

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps,
    mergeProps
  )(ContextMenu)
)
